function TriangleUp({ className }) {
  return (
    <svg viewBox="5 4 14 8" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" strokeLinecap="round" className={className}>
      <path d="M8.5 11l2.7-4.6a1 1 0 0 1 1.6 0L15.5 11" />
    </svg>
  );
}

function TriangleDown({ className }) {
  return (
    <svg viewBox="5 12 14 8" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" strokeLinecap="round" className={className}>
      <path d="M15.5 13l-2.7 4.6a1 1 0 0 1-1.6 0L8.5 13" />
    </svg>
  );
}

function TriangleBoth({ className }) {
  return (
    <svg viewBox="5 4 14 16" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" strokeLinecap="round" className={className}>
      <path d="M8.5 11l2.7-4.6a1 1 0 0 1 1.6 0L15.5 11" />
      <path d="M15.5 13l-2.7 4.6a1 1 0 0 1-1.6 0L8.5 13" />
    </svg>
  );
}

function FunnelIcon({ className }) {
  return (
    <svg viewBox="3 2 19 19" fill="currentColor" className={className}>
      <path d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 .78 1.625L14 12.5V19a1 1 0 0 1-1.447.894l-4-2A1 1 0 0 1 8 17v-4.5L3.22 5.625A1 1 0 0 1 3 5V4z" />
    </svg>
  );
}

export { TriangleUp, TriangleDown, TriangleBoth, FunnelIcon };
